<template>
  <div class="row">
    <div class="col-md-12">
      <div class="m-portlet m-portlet--tab">
        <div data-cy="dashboardDiv" class="m-portlet__body">
          <div
            class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-3 border-bottom"
          >
            <h1 class="h2">Dashboard</h1>
            <div class="btn-toolbar mb-2 mb-md-0"></div>
          </div>
          <div class="m-content">
            <p>Bem vindo ao Griffin.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  title: 'Dashboard',
};
</script>

<style></style>
